  function updateGuaranteeText() {
    const productSectionText = document.getElementById("30-day-moneyback");
    if (productSectionText) productSectionText.textContent = "90-day money-back guarantee";

    const cartDrawerTextContainer = document.querySelector("#CartDrawerForm > div.drawer__inner > div.drawer__footer.appear-animation.appear-delay-4 > div.cart__notes > div:nth-child(1)");
    if (cartDrawerTextContainer) {
      cartDrawerTextContainer.innerHTML = cartDrawerTextContainer.innerHTML.replace("30-day", "90-day");
    }
  }

  function checkGuaranteeText() {
    if (document.querySelector('[data-product-id="8627846578339"]')) {
      updateGuaranteeText();
    }
  }

  function removeAnnouncementBarFromHeader() {
    const announcementBar = document.querySelector('#HeaderWrapper .announcement');
    if (announcementBar) {
      announcementBar.remove();
    }
  }

  function insertPromotionalBannerAfterHeader(bannerContent, bannerStyleClass) {
    const bannerHTML = `
      <div class="${bannerStyleClass} promo-banner">
        <div class="page-width">
          <div class="promo-wrapper">
            ${bannerContent}
          </div>
        </div>
      </div>
    `;
    const header = document.querySelector('#PageContainer [data-section-type="header"]');
    header.insertAdjacentHTML('afterend', bannerHTML);
  }

  function insertForbes15PercentOffBanner() {
    const forbesPromotionalContent = `
      <div class="forbes-logo">
        <img src="https://cdn.shopify.com/s/files/1/0079/9994/6842/files/forbes-logo-white.svg" alt="Forbes" width="78" height="19">
      </div>
      <div class="forbes-offer">
        Limited time offer: <br class="forbes-linebreak" /><strong>15% off</strong>, automatically applied.
      </div>
    `
    insertPromotionalBannerAfterHeader(forbesPromotionalContent, "forbes-banner");
  }

  function insertDeliveryRank15PercentOffBanner() {
    const deliveryRankPromotionalContent = `
      <div class="deliveryrank-logo">
        <img src="https://cdn.shopify.com/s/files/1/0079/9994/6842/files/deliveryRank_trademark.png?v=1755716134" alt="DeliveryRank logo" height="40">
      </div>
      <div class="deliveryrank-offer">
        Limited time offer: <br class="deliveryrank-linebreak" /><strong>15% off</strong>, automatically applied.
      </div>
    `
    insertPromotionalBannerAfterHeader(deliveryRankPromotionalContent, "deliveryrank-banner");
  }

  function insertTopNutritionCoaching15PercentOffBanner() {
    // do not proceed if not in path /products/supergreens or already has banner
    if (!window.location.pathname.includes("/products/supergreens") || document.querySelector('.tnc-banner')) {
      return;
    }
    const topNutritionPromotionalContent = `
      <div class="tnc-logo">
        <img src="https://cdn.shopify.com/s/files/1/0079/9994/6842/files/top-nutrition-coaching-logo-white.svg?v=1742477927" alt="Top Nutrition Coaching" width="133">
      </div>
      <div class="tnc-offer">
        For a limited time only, enjoy a <span class="no-break">special <strong>15% off</strong></span>, automatically applied.
      </div>
    `
    insertPromotionalBannerAfterHeader(topNutritionPromotionalContent, "tnc-banner");
  }

  function insertYoutube15PercentOffBanner() {
    const youtubePromotionalContent = `
      <div class="youtube-logo tnc-logo">
        <img src="https://cdn.shopify.com/s/files/1/0079/9994/6842/files/youtube-logo-word.svg?v=1746019428" alt="Youtube Logo" width="140" height="auto">
      </div>
      <div class="youtube-offer tnc-offer">
        For a limited time only, enjoy a <span class="no-break">special <strong>15% off</strong></span>, automatically applied.
      </div>
    `
    insertPromotionalBannerAfterHeader(youtubePromotionalContent, "youtube-banner");
  }

  function insertOxfordRoad15PercentOffBanner() {
    const oxfordRoadPromotionalContent = `
      <div class="mic-emoji wiggle-once">
        🎤
      </div>
      <div class="oxford-road-offer">
        <span style="font-weight: 600;">Podcast listeners:</span> Enjoy <span class="no-break">15% off,</span> automatically applied.
      </div>
    `
    insertPromotionalBannerAfterHeader(oxfordRoadPromotionalContent, "oxfordroad-banner");
  }

  function insertRoktPercentOffBanner(percentage) {
    const roktPromotionalContent = `
      <div class="rokt-emoji wiggle-once">
        🤑
      </div>
      <div class="rokt-offer">
        Limited time offer: Take <strong>${percentage}% off</strong>, automatically applied.
      </div>
    `;
    insertPromotionalBannerAfterHeader(roktPromotionalContent, "rokt-banner");
  }
  
  function setupYoutubeReferralAttributes() {
    insertYoutube15PercentOffBanner();
    removeAnnouncementBarFromHeader();
    sessionStorage.setItem('referrer', 'youtube');
    return {
      referrer: "youtube",
      __impactid: ""
    };
  }

  function setupForbesReferralAttributes(impactPartnerId) {
    insertForbes15PercentOffBanner();
    removeAnnouncementBarFromHeader();
    sessionStorage.setItem('referrer', 'forbes');
    return {
      referrer: "forbes",
      ...(impactPartnerId && { __impactid: impactPartnerId })
    };
  }

  function setupDeliveryRankReferralAttributes(impactPartnerId) {
    insertDeliveryRank15PercentOffBanner();
    removeAnnouncementBarFromHeader();
    sessionStorage.setItem('referrer', 'deliveryrank15');
    return {
      referrer: "deliveryrank15",
      ...(impactPartnerId && { __impactid: impactPartnerId })
    };
  }
  
  function setupTopNutritionCoachingReferralAttributes() {
    insertTopNutritionCoaching15PercentOffBanner();
    removeAnnouncementBarFromHeader();
    sessionStorage.setItem('referrer', 'topnutritioncoaching');
    return {
      referrer: "topnutritioncoaching",
      __impactid: ""
    };
  }

  function setupOxfordRoadReferralAttributes(discountCode) {
    insertOxfordRoad15PercentOffBanner();
    removeAnnouncementBarFromHeader();
    sessionStorage.setItem('referrer', 'oxfordroad');

    // Persist the oxfordroad-specific referrer code
    if (typeof discountCode === 'string' && discountCode.trim()) {
      try { sessionStorage.setItem('oxfordroad_referrer', discountCode.trim()); } catch (e) {}
    } else {
      try { discountCode = sessionStorage.getItem('oxfordroad_referrer') || ''; } catch (e) { discountCode = ''; }
    }

    // No redirect here; discount application handled elsewhere
    return {
      referrer: discountCode || 'oxfordroad',
      __impactid: ""
    };
  }

  function setupRoktReferralAttributes(discountParam) {
    let percentage = 15;
    if (discountParam === '10' || discountParam === '15') {
      percentage = parseInt(discountParam);
    }
    insertRoktPercentOffBanner(percentage);
    removeAnnouncementBarFromHeader();
    const referrerCode = `rokt${percentage}`;
    sessionStorage.setItem('referrer', referrerCode);
    return {
      referrer: referrerCode,
      __impactid: ""
    };
  }

  async function determinePromotionalBannerAttributes(currentCart, referralParams) {  
    const {
      irpid: impactPartnerId,
      nb_partner_name: nanobotsPartnerName,
      utm_source: utmSource,
      utm_content: utmContent
    } = referralParams;
    
    // Check if visitor came from Forbes
    const isForbesReferral = impactPartnerId === '1955282' || nanobotsPartnerName === "Forbes-MKTP";
    if (isForbesReferral) {
      return setupForbesReferralAttributes(impactPartnerId);
    }

    // Check if visitor came from DeliveryRank
    const isDeliveryRankReferral = impactPartnerId === '2034726';
    if (isDeliveryRankReferral) {
      return setupDeliveryRankReferralAttributes(impactPartnerId);
    }

    // Check if visitor came from Youtube
    const isYoutubeReferral = utmSource?.includes("youtube");
    if (isYoutubeReferral) {
      return setupYoutubeReferralAttributes();
    }

    // Check if visitor came from Oxford Road
    const isOxfordRoadReferral = (utmSource || '').toLowerCase().includes('oxfordroad');
    if (isOxfordRoadReferral) {
      return setupOxfordRoadReferralAttributes(utmContent);
    }

    // Check if visitor came from Rokt
    const isRoktReferral = (utmSource || '').toLowerCase() === 'rokt';
    if (isRoktReferral) {
      return setupRoktReferralAttributes(utmContent);
    }

    // // Check if visitor came from Top Nutrition Coaching initially
    // const isTopNutritionCoachingReferral = (
    //   document.referrer.includes("topnutritioncoaching.com") || utmSource?.includes("topnutritioncoaching")
    // );
    // if (isTopNutritionCoachingReferral) {
    //   return setupTopNutritionCoachingReferralAttributes();
    // }

    // Check session storage for existing referral
    const sessionReferrer = sessionStorage.getItem('referrer');
    if (sessionReferrer === 'forbes') {
      return setupForbesReferralAttributes();
    }
    if (sessionReferrer === 'deliveryrank15') {
      return setupDeliveryRankReferralAttributes();
    }
    if (sessionReferrer === 'youtube') {
      return setupYoutubeReferralAttributes();
    }
    if (sessionReferrer === 'topnutritioncoaching') {
      return setupTopNutritionCoachingReferralAttributes();
    }
    if (sessionReferrer === 'oxfordroad') {
      return setupOxfordRoadReferralAttributes(null);
    }

    if (sessionReferrer.startsWith('rokt')) {
      const percentage = parseInt(sessionReferrer.slice(4)) || 15;
       return setupRoktReferralAttributes(percentage);
    }

    // Only remove cart attributes if there are existing discounts
    if (currentCart.cart_level_discount_applications?.length) {
      return {
        referrer: "",
        __impactid: ""
      };
    }

    return {};
  }

  async function initializeReferralBannersAndGuaranteeText(overrideReferrer = null) {
    window.cartAttributesReferrerState = "loading";
    checkGuaranteeText();
    
    const referralUrlParams = theme.utils.getQueryVariables([
      'irpid',
      'nb_partner_name',
      'utm_source',
      'utm_content'
    ]) || {};

    let cartAttributes = {};
    // if overrideReferrer is provided, use it to set cart attributes
    if (overrideReferrer === 'forbes') {
      cartAttributes = setupForbesReferralAttributes(referralUrlParams.irpid);
    } else if (overrideReferrer === 'youtube') {
      cartAttributes = setupYoutubeReferralAttributes();
    } else if (overrideReferrer === 'topnutritioncoaching') {
      cartAttributes = setupTopNutritionCoachingReferralAttributes();
    } else if (overrideReferrer === 'deliveryrank15') {
      cartAttributes = setupDeliveryRankReferralAttributes(referralUrlParams.irpid);
    } else if ((referralUrlParams.utm_source || '').toLowerCase().includes('oxfordroad')) {
      cartAttributes = setupOxfordRoadReferralAttributes(referralUrlParams.utm_content);
    } else {
      const currentCart = await theme.cart.getCart();
      cartAttributes = await determinePromotionalBannerAttributes(currentCart, referralUrlParams);
    }
    
    if (Object.keys(cartAttributes).length) {
      await theme.cart.updateCartAttributes(cartAttributes);
      // refresh cart if there are changes to attributes
      document.dispatchEvent(new CustomEvent('ajaxCartRefreshWithoutOpen'));
    }

    
    window.cartAttributesReferrerState = "loaded";
    document.dispatchEvent(new CustomEvent('promotion:cartAttributesProcessed', { detail: cartAttributes }));
  }

  theme.DOMready(initializeReferralBannersAndGuaranteeText);
  theme.utils.initializeReferralBannersAndGuaranteeText = initializeReferralBannersAndGuaranteeText;
